import { Link } from "react-router-dom";
import { categories } from "@/mocks/articles";

interface Article {
  slug: string;
  title: string;
  excerpt: string;
  category: string;
  coverImage: string;
  author: string;
  date: string;
  readTime: string;
  tags: string[];
}

export default function ArticleCard({ article }: { article: Article }) {
  const category = categories.find((c) => c.slug === article.category);

  return (
    <article className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300">
      <Link to={`/article/${article.slug}`} className="block">
        <div className="relative w-full aspect-[16/10] overflow-hidden">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
      </Link>
      <div className="p-4 md:p-5">
        {category && (
          <Link
            to={`/category/${category.slug}`}
            className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-2 py-1 rounded-md mb-3 hover:bg-primary-100 transition-colors whitespace-nowrap"
          >
            {category.name}
          </Link>
        )}
        <Link to={`/article/${article.slug}`} className="block">
          <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4">
            {article.excerpt}
          </p>
        </Link>
        <div className="flex items-center justify-between text-xs text-foreground-500">
          <div className="flex items-center gap-3">
            <span>{article.author}</span>
            <span className="text-foreground-300">·</span>
            <span>{article.date}</span>
          </div>
          <span>{article.readTime}</span>
        </div>
      </div>
    </article>
  );
}